// TOKEN OPERATION
const storeAdminToken = (token) => {
    localStorage.setItem('token', token);
};

const getAdminToken = () => {
    return localStorage.getItem('token');
};

const removeAdminToken = () => {
    localStorage.removeItem('token');
};

const isAdminLoggedIn = () => {
    return !!localStorage.getItem('token');
};

export { storeAdminToken, getAdminToken, removeAdminToken, isAdminLoggedIn }